import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

export interface FaqItem {
  question: string;
  answer: string;
  created_date: string;
}

@Injectable({ providedIn: 'root' })
export class FaqService {
  // Replace these paths when the backend endpoints are available.
  private readonly faqEndpoint = `${environment.API_URL}/orders/get/faq/`;
  private readonly helpEndpoint = `${environment.API_URL}/orders/get/help-documents/`;

  constructor(private http: HttpClient) {}

  private handleError1(errorResponse: HttpErrorResponse) {
    if (errorResponse.error instanceof ErrorEvent) {
      console.error('Client-side error:', errorResponse.error.message);
    } else {
      console.error('Server-side error:', errorResponse.status, errorResponse.message);
    }
    return throwError(() => errorResponse);
  }

  getFaqs(payload:any = {}): Observable<any> {
     return this.http
      .post(this.faqEndpoint, payload)
      .pipe(catchError(this.handleError1));
  }

  getHelpDocuments(payload: any = {}): Observable<any> {
    return this.http
      .post(this.helpEndpoint, payload)
      .pipe(catchError(this.handleError1));
  }

}
